import React from 'react';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import SecurityList from 'components/Agile/security/securityList';
import AppModuleHeader from 'components/AppModuleHeader/index';
import SecurityAdd from 'components/Agile/security/securityAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';

const filterOptions = [
    {
        id: 1,
        name: 'All securitys',
        icon: 'zmdi-menu'
    }, {

        id: 2,
        name: 'Starred securitys',
        icon: 'zmdi-star'
    }
];

export class Component extends React.Component {

    securitySideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.securitys" /></span>
                </div>
            </div>


            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={this.onAddSecurity}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span>Add New Security</span>
                        </Button>
                    </div>
                    <div className="module-side-nav">
                        <ul className="module-nav">
                            {filterOptions.map(option => <li key={option.id} className="nav-item">
                                <a href="javascript:void(0)"
                                    className={option.id === this.props.selectedSectionId ? 'active' : ''} onClick={
                                        this.onFilterSecurityOptionSelect.bind(this, option)
                                    }>
                                    <i className={`zmdi ${option.icon}`} />
                                    <span>{option.name}</span>
                                </a>
                            </li>
                            )}

                        </ul>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    addFavouriteSecurity = (data) => {
        this.props.addFavouriteSecurity(data);
    };
    onSecuritySelect = (data) => {
        this.props.onSecuritySelect(data);
    };
    onAddSecurity = () => {
        this.props.onAddSecurity();
    };
    onSecurityClose = () => {
        this.props.onSecurityClose();
    };
    onFilterSecurityOptionSelect = (option) => {
        this.props.onFilterSecurityOptionSelect(option);
    };
    onSaveSecurity = (data) => {
        this.props.onSaveSecurity(data);
    };
    onDeleteSecurity = (data) => {
        this.props.onDeleteSecurity(data);
    };
    onFilterSelectedSecurity = () => {
        this.props.onFilterSelectedSecurity();
    };
    filterSecurity = (securityName) => {
        if (securityName === '') {
            this.onFilterSecurityOptionSelect(this.props.filterOption);
        } else {
            this.props.filterSecurity(securityName);
        }
    };
    handleSecurityRequestClose = () => {
        this.props.handleSecurityRequestClose();
    };
    getAllSecurity = () => {
        this.props.getAllSecurity();
    };
    getUnselectedAllSecurity = () => {
        this.props.getUnselectedAllSecurity();
    };
    onAllSecuritySelect = () => {
        const selectAll = this.props.selectedSecuritys < this.props.securityList.length;
        if (selectAll) {
            this.props.getAllSecurity();
        } else {
            this.props.getUnselectedAllSecurity();
        }
    };
    onToggleSecurityDrawer = () => {
        this.props.onToggleSecurityDrawer();
    };
    showSecurityLoader = () => {
        this.props.showSecurityLoader();
    }

    constructor() {
        super();
    }
    componentDidMount() {
        this.props.showSecurityLoader();
        this.props.fetchSecuritys();
    }
    updateSearchSecurity(evt) {
        this.props.updateSearchSecurity(evt.target.value);
        this.props.filterSecurity(evt.target.value);
    }

    render() {
        const { width, security, securityList, addSecurityState, selectedSecuritys, alertMessage, showMessage, drawerState, noContentFoundMessage, loader } = this.props;
        return (
            <div className="app-wrapper">
                <div className="app-module animated slideInUpTiny animation-duration-3">
                    <div className="d-block d-xl-none">
                        <Drawer
                            touch={true}
                            transitions={true}
                            enableDragHandle={true}
                            open={drawerState}
                            onOpenChange={this.onToggleSecurityDrawer.bind(this)}
                            sidebar={this.securitySideBar(security)} />
                    </div>
                    <div className="app-module-sidenav d-none d-xl-flex">
                        {this.securitySideBar(security)}
                    </div>
                    <div className="module-box">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={this.onToggleSecurityDrawer.bind(this)}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                            <AppModuleHeader placeholder="Search security" notification={false} apps={false}
                                user={this.props.security}
                                onChange={this.updateSearchSecurity.bind(this)}
                                value={this.props.searchSecurity} />
                        </div>
                        <div className="module-box-content">
                            <div className="module-box-topbar align-items-center">
                                <div className="form-control-checkbox d-flex">
                                    <div className="form-checkbox">
                                        <input type="checkbox"
                                            checked={selectedSecuritys > 0}
                                            onChange={this.onAllSecuritySelect.bind(this)} />
                                        <span className="check">
                                            <i className="zmdi zmdi-check zmdi-hc-lg" />
                                        </span>
                                    </div>
                                </div>
                                <Button size="sm" className="jr-btn jr-flat-btn" color="default"
                                    onClick={this.onFilterSelectedSecurity.bind(this)} >
                                    <i className="zmdi zmdi-filter-list zmdi-hc-fw" />
                                    <span><IntlMessages id="label.filter.selected" /></span>
                                </Button>
                            </div>
                            <CustomScrollbars className="module-list-scroll scrollbar"
                                style={{ height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)' }}>
                                {loader ?
                                    <div
                                        className="loader-view-block h-100">
                                        <div className="loader-view">
                                            <CircularProgress />
                                        </div>
                                    </div>
                                    :
                                    securityList && securityList.length > 0 ?
                                        <SecurityList data={securityList} width={width}
                                            addFavouriteSecurity={this.addFavouriteSecurity.bind(this)}
                                            onSecuritySelect={this.onSecuritySelect.bind(this)}
                                            onDeleteSecurity={this.onDeleteSecurity.bind(this)}
                                            onSaveSecurity={this.onSaveSecurity.bind(this)}
                                            showSecurityLoader={this.showSecurityLoader.bind(this)} />
                                        :
                                        <div className="h-100 d-flex align-items-center justify-content-center">
                                            {noContentFoundMessage}
                                        </div>
                                }
                            </CustomScrollbars>

                        </div>
                    </div>
                </div>
                <SecurityAdd
                    open={addSecurityState}
                    security={{
                        'id': '',
                        'orgid': '',
                        'name': '',
                        'key': '',
                        'url': '',
                        'account': '',
                        'thumb': null,
                        'selected': false,
                        'starred': false,
                        'frequently': false,
                    }}
                    onSaveSecurity={this.onSaveSecurity}
                    onSecurityClose={this.onSecurityClose}
                    onDeleteSecurity={this.onDeleteSecurity}
                    showSecurityLoader={this.showSecurityLoader}
                />

                {showMessage && NotificationManager.success(alertMessage, this.handleSecurityRequestClose())}
                <NotificationContainer />

            </div>
        );
    }
}

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/security/component.js